import _ from 'lodash';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ITenant2PlaceRow, ITenant2ZoneRow } from '../../../../../../../../General.interfaces';
import { generalReducerValues } from '../../../../../../../../General.reducer';
import { filterValidDateRanges } from '../../../../../../../../tools/filterValidDateRanges';
import { numberWithSpaces } from '../../../../../../../../tools/Strings/numberWithSpaces';
import { useWidgetCurrentOptions } from '../../../../../../../../tools/useWidgetCurrentOptions';
import { Leasing_TenantOverview_Module_Reducer_Values } from '../../../reducer';
import { storePreraredData } from '../reducer';

const infoMap = {
    sumArea: 'Total area',
    placeNames: 'Places',
    floors: 'Floors',
    zones: 'Zones',
    categories: 'Categories',
};

export const usePrepareData = () => {
    const { selectedLocationId, structures } = useSelector(generalReducerValues);
    const { moduleName } = useSelector(Leasing_TenantOverview_Module_Reducer_Values);
    const localCurrentOptions = useWidgetCurrentOptions(moduleName);
    const { t } = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!structures?.relations_tenant2place || !structures?.relations_tenant2zone) return;
        const mainPeriod = localCurrentOptions?.mainPeriod?.id;
        const mainDateRange = localCurrentOptions?.mainDateRanges?.filter((item) => item.id === mainPeriod)[0];

        const filteredTenant2place = filterValidDateRanges(
            structures.relations_tenant2place?.filter((item: ITenant2PlaceRow) => {
                return item.tenant_id === localCurrentOptions?.['tenants']?.[0].id;
            }),
            mainDateRange?.period,
        );

        const filteredTenant2zone = filterValidDateRanges(
            structures.relations_tenant2zone?.filter((item: ITenant2ZoneRow) => {
                return item.tenant_id === localCurrentOptions?.['tenants']?.[0].id;
            }),
            mainDateRange?.period,
        );

        const sumArea = numberWithSpaces(
            filteredTenant2place?.reduce((acc, item: ITenant2PlaceRow) => {
                return acc + item.area;
            }, 0),
        );

        const placeNames = _.uniq(
            filteredTenant2place?.reduce((acc, item: ITenant2PlaceRow) => {
                return [...acc, item.place_name];
            }, []),
        ).join(', ');

        const floors = _.uniq(
            filteredTenant2place?.reduce((acc, item: ITenant2PlaceRow) => {
                return [...acc, item.floor];
            }, []),
        ).join(', ');

        const zones = _.uniq(
            filteredTenant2zone?.reduce((acc, item: ITenant2ZoneRow) => {
                return [...acc, item.zone_name];
            }, []),
        ).join(', ');

        const categories = _.uniq(
            filteredTenant2zone?.reduce((acc, item: ITenant2ZoneRow) => {
                return [...acc, item.zone_name];
            }, []),
        ).join(', ');

        const preparedData = [
            {
                key: 'sumArea',
                data: sumArea,
                name: t(infoMap.sumArea),
            },
            {
                key: 'placeNames',
                data: placeNames,
                name: t(infoMap.placeNames),
            },
            {
                key: 'floors',
                data: floors,
                name: t(infoMap.floors),
            },
            {
                key: 'zones',
                data: zones,
                name: t(infoMap.zones),
            },
            {
                key: 'categories',
                data: categories,
                name: t(infoMap.categories),
            },
        ];

        dispatch(storePreraredData(preparedData));
    }, [dispatch, localCurrentOptions, selectedLocationId, t, structures]);
};
